export default __webpack_public_path__ + "static/pdp-physician-reviewed-e6642ce132b36c00a643f93d86809d64.svg";